// extracted by mini-css-extract-plugin
module.exports = {"h6h3wkc":"h6h3wkc","sn741d4":"sn741d4"};